import { Rule } from 'antd/lib/form';

export default function fieldRules(rules: (Rule & { enabled: boolean })[]) {
  return rules.filter((rule) => rule.enabled);
}
